import { serviceClient } from '@yola/ws-sdk';

const getStatus = (jobId) => {
  const client = serviceClient.get();
  return client.getAsyncJob(jobId);
};

export default getStatus;
